export const getters = {
  getExpensesItemDetails: state => state.itemDetails,
  getCreditCards: state => state.creditCards,
  getCreditCardsLoadingStatus: state => state.creditCardsLoadingStatus,
  getCreditAccounts: state => state.creditAccounts,
  getInvestmentAccounts: state => state.investmentAccounts,
  getCryptocurrencyAccounts: state => state.cryptocurrencyAccounts,
  getAccountsLoadingStatus: state => state.accountsLoadingStatus,
  getFoodAndHousing: state => state.foodAndHousing,
  getFoodAndHousingLoadingStatus: state => state.foodAndHousingLoadingStatus,
  getTransportationAndMedical: state => state.transportationAndMedical,
  getTransportationAndMedicalLoadingStatus: state => state.transportationAndMedicalLoadingStatus,
  getOtherLivingExpenses: state => state.otherLivingExpenses,
  getAdditionalFiles: state => state.additionalExpensesFiles,
  getOtherLivingExpensesLoadingStatus: state => state.otherLivingExpensesLoadingStatus,
};
